// a list of tokens by chain
import { Currency, Token } from '@intrinsic-network/sdk-core'

import { SupportedChainId } from './chains'
import { BPD, MP, nativeOnChain, USDT0, WRAPPED_NATIVE_CURRENCY } from './tokens'

type ChainTokenList = {
  readonly [chainId: number]: Token[]
}

type ChainCurrencyList = {
  readonly [chainId: number]: Currency[]
}

const WRAPPED_NATIVE_CURRENCIES_ONLY: ChainTokenList = Object.fromEntries(
  Object.entries(WRAPPED_NATIVE_CURRENCY)
    .map(([key, value]) => [key, [value]])
    .filter(Boolean)
)

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  ...WRAPPED_NATIVE_CURRENCIES_ONLY,
}

export const ADDITIONAL_BASES: { [chainId: number]: { [tokenAddress: string]: Token[] } } = {}
/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 */
export const CUSTOM_BASES: { [chainId: number]: { [tokenAddress: string]: Token[] } } = {}

/**
 * Shows up in the currency select for swap and add liquidity
 */
export const COMMON_BASES: ChainCurrencyList = {
  [SupportedChainId.RSK_TESTNET]: [
    nativeOnChain(SupportedChainId.RSK_TESTNET),
    BPD[SupportedChainId.RSK_TESTNET] as Token,
    MP[SupportedChainId.RSK_TESTNET] as Token,
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.RSK_TESTNET] as Token,
  ],
  [SupportedChainId.RSK_MAINNET]: [
    nativeOnChain(SupportedChainId.RSK_MAINNET),
    BPD[SupportedChainId.RSK_MAINNET] as Token,
    MP[SupportedChainId.RSK_MAINNET] as Token,
    USDT0[SupportedChainId.RSK_MAINNET] as Token,
    WRAPPED_NATIVE_CURRENCY[SupportedChainId.RSK_MAINNET] as Token,
  ],
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  ...WRAPPED_NATIVE_CURRENCIES_ONLY,
}
export const PINNED_PAIRS: { readonly [chainId: number]: [Token, Token][] } = {}
